// const API_KEY = `AIzaSyC-7PmFmrUz-5DqhyjDWvQX-XKd2cbXhZY`;
// CLIENT KEY: const API_KEY = `AIzaSyCLXCGL5N0XeEyFy8WeRpH9quLiKSm5Als`;
// PERSONAL KEY (TO UPDATE: https://console.cloud.google.com/apis/credentials/key/7831edd5-31c4-4c03-90d0-c8b5e9628805?authuser=2&project=j-band-map)
const API_KEY = `AIzaSyAmE32sjlm-BwO2ADzlhPbC7rSz95QC6PU`;
const CALLBACK_NAME = `gmapsCallback`;

let initialized = !!window.google;
let resolveInitPromise;
let rejectInitPromise;

// This promise handles the initialization
// status of the google maps script.
const initPromise = new Promise((resolve, reject) => {
    resolveInitPromise = resolve;
    rejectInitPromise = reject;
});

export default function init() {
    // If Google Maps already is initialized
    // the `initPromise` should be resolved
    // eventually.
    if (initialized) return initPromise;

    initialized = true;
    // The callback function is called by
    // the Google Maps script if it is
    // successfully loaded.
    window[CALLBACK_NAME] = () => resolveInitPromise(window.google);

    // We inject a new script tag into
    // the `<head>` of our HTML to load
    // the Google Maps script.
    const script = document.createElement(`script`);
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}`;
    script.onerror = rejectInitPromise;
    document.querySelector(`head`).appendChild(script);

    return initPromise;
}
